import { render, staticRenderFns } from "./SentMailDetail.vue?vue&type=template&id=158cf7c6"
import script from "./SentMailDetail.vue?vue&type=script&lang=js"
export * from "./SentMailDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('158cf7c6')) {
      api.createRecord('158cf7c6', component.options)
    } else {
      api.reload('158cf7c6', component.options)
    }
    module.hot.accept("./SentMailDetail.vue?vue&type=template&id=158cf7c6", function () {
      api.rerender('158cf7c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/mailbox/SentMailDetail.vue"
export default component.exports